import React from "react";
import { Container } from "@mui/material";

import { AppShell } from "../AppShell";
import { WrapperContainer } from "./Wrapper.style";

import { WrapperProps } from "../../../shared/models/component/base.model";

export const Wrapper = ({
  type = "sm",
  children,
  isFullScreen = false,
  isAuthorizedWrapper,
  iAuthorizedHeaderDesktopFixed = true,
  isTabNavigationAvailable = false,
  isSettingDesktop,
  idSelector = "wrapperContainer",
}: WrapperProps) => {
  // Authorized screens render inside the AppShell (desktop sidebar / mobile
  // tab bar) unconditionally. This was briefly gated behind the tpUiV2Shell
  // LaunchDarkly flag as a kill-switch, but the audit showed flag-off was a
  // trap: swept screens no longer carry the legacy header nav, so the legacy
  // path rendered a nav-less app. Rollback story is "redeploy the previous
  // version", so the flag (and its LD/deploy coupling) was removed.

  /**
   * Return primary Ui interaction
   */
  return (
    <>
      {!isAuthorizedWrapper && (
        <WrapperContainer id={idSelector}>
          <Container
            maxWidth={type}
            sx={{
              height: "auto",
              position: "relative",
            }}
          >
            {children}
          </Container>
        </WrapperContainer>
      )}

      {isAuthorizedWrapper && <AppShell>{children}</AppShell>}
    </>
  );
};
